/** WhatsApp links for Bolivian phone numbers (any 8-digit mobile, whichever digit it starts with) */

/** "7xxxxxxx", "+591 5xxxxxxx", "00591…" → "591XXXXXXXX"; null when it is not a usable number */
export function bolivianWhatsAppNumber(raw: string | null | undefined): string | null {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (digits.length === 8) return `591${digits}`;
  if (digits.length === 11 && digits.startsWith('591')) return digits;
  if (digits.length === 13 && digits.startsWith('00591')) return digits.slice(2);
  return null;
}

/** Chat with the number when usable, otherwise the contact picker; message always prefilled */
export function whatsappShareUrl(phone: string | null | undefined, message: string): string {
  return whatsappUrl(phone, message) ?? `https://wa.me/?text=${encodeURIComponent(message)}`;
}

/** wa.me link with a ready message, or null when the phone is not usable */
export function whatsappUrl(phone: string | null | undefined, message: string): string | null {
  const number = bolivianWhatsAppNumber(phone);
  return number ? `https://wa.me/${number}?text=${encodeURIComponent(message)}` : null;
}
